import React from 'react';
import styled from 'styled-components';
import { ColorNordicGrey1 } from 'autogen/design-tokens/tokens';
import DropdownContent from 'components/dropdown/partials/DropdownContent';

const StyledDropdownContent = styled(DropdownContent)<{ isVisible: boolean }>`
    border-radius: 0;
    border: 1px solid;
    border-color: ${ColorNordicGrey1};
    border-top-color: transparent;
    box-shadow: none;
    margin-top: -2px;
`;

export default function ChanelDropdownContent(props) {
    return <StyledDropdownContent {...props} />;
}
